import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useWindowSize } from "go-core/components/useWindowSize";
import Search from "go-list/core/components/Search";
import { partnerApi } from "../../../../../../../services/Api/Partner/partnerApi";
import { PartnerApi } from "../../../../../../../services/Api/Partner/partnerTypes";
import DashboardOrganizationModal from "./DashboardOrganizationModal";

interface Props {
	setSearch: (value: React.SetStateAction<string>) => void;
	setPartners: React.Dispatch<React.SetStateAction<PartnerApi[]>>;
	setShowNewOrganizationModal: React.Dispatch<React.SetStateAction<boolean>>;
	showNewOrganizationModal: boolean;
	partners: PartnerApi[];
}

const UserDashboardHeader = ({
	setSearch,
	setPartners,
	setShowNewOrganizationModal,
	showNewOrganizationModal,
	partners,
}: Props) => {
	const isMobile = useWindowSize().isMobile;
	const { t } = useTranslation();
	const history = useHistory();
	const { addFlash } = useFlash();

	const handleOpenOrganizationModal = async () => {
		try {
			const res = await partnerApi.getPartners({ include: "parent" });
			setPartners(res);
			if (!res || res.length <= 0) {
				history.push("/register");
			} else {
				setShowNewOrganizationModal(true);
			}
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const renderActions = () => {
		return (
			<div className="content-actions">
				<div>
					<Search onChange={(e) => setSearch(e)} />
				</div>
				<button onClick={handleOpenOrganizationModal} className="btn btn-primary">
					+ {t("modules.dashboard.action.create_organization.title")}
				</button>
				<DashboardOrganizationModal
					show={showNewOrganizationModal}
					partners={partners}
					onHide={() => setShowNewOrganizationModal(false)}
				/>
			</div>
		);
	};

	return (
		<div className="content-header">
			<div className="d-flex align-items-baseline">
				{!isMobile && (
					<div className="content-header-title">
						<h1>{t("lib:common.word.locations")}</h1>
					</div>
				)}
			</div>
			{renderActions()}
		</div>
	);
};

export default UserDashboardHeader;
